var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M10.8551 0.387897C11.4739 0.0306314 12.2363 0.0306316 12.8551 0.387897L22.4632 5.93515C23.082 6.29241 23.4632 6.95267 23.4632 7.6672V18.7617C23.4632 19.4762 23.082 20.1365 22.4632 20.4937L12.8551 26.041C12.2363 26.3983 11.4739 26.3983 10.8551 26.041L1.24695 20.4937C0.628152 20.1365 0.246954 19.4762 0.246954 18.7617V7.6672C0.246954 6.95267 0.628152 6.29241 1.24695 5.93515L10.8551 0.387897Z",
    fill: "#F1AF13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumOne);
export default __webpack_public_path__ + "static/media/numOne.2b7ff597e54ca26da3912f9b5fadfa86.svg";
export { ForwardRef as ReactComponent };